/** Discover → Agents (AUTO-8). Shows clone hint for system agents. */

import { createFileRoute } from '@tanstack/react-router';
import { Bot } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/agents')({
  component: DiscoverAgentsPage,
});

function DiscoverAgentsPage() {
  return (
    <CatalogBrowsePage
      kind="agent"
      title="Agents"
      description="Pre-built agent templates you can clone into your tenant. Each agent composes a model brand + system prompt + assigned tools + skills. Cloning creates a tenant-scoped copy you can then edit."
      icon={Bot}
      cloneEndpoint="/api/v1/agents/clone"
    />
  );
}
